import { IContentProps } from "./content-props";
import { ISearchResultDTO } from "../DTO/search";

export interface IGlobalSort<T> {
    sortId: string;
    display: string;
    selected: boolean;
    sortRule?: (a: T, b: T) => number;
    inactive?: boolean;
}

export enum ISortDirection {
    NO_DIRECTION,
    ASCENDING,
    DESCENDING
}

export enum ISortField {
    NONE,
    DATE
}

export interface ISort {
    display: string;
    sortField: ISortField;
    selected: boolean;
    direction: ISortDirection;
    id: string;
}

export const searchSortModel: ISort[] = [
    {
        display: '',
        sortField: ISortField.NONE,
        selected: true,
        direction: ISortDirection.NO_DIRECTION,
        id: 'relevance',
    },
    {
        display: '',
        sortField: ISortField.DATE,
        selected: false,
        direction: ISortDirection.DESCENDING,
        id: 'newest',
    },
    {
        display: '',
        sortField: ISortField.DATE,
        selected: false,
        direction: ISortDirection.ASCENDING,
        id: 'oldest',
    },
];

export function GetSorts(sortsModel: ISort[], contentProps: IContentProps): IGlobalSort<ISearchResultDTO>[] {
    return sortsModel.map((sort, i, arr) => {
        let newSort: IGlobalSort<ISearchResultDTO> = {
            display: getDisplayName(sort.id, contentProps),
            sortId: sort.id,
            selected: sort.selected
        };
        return newSort;
    });
}

function getDisplayName(id: string, contentProps: IContentProps) {
    switch (id) {
        case 'relevance':
            return contentProps.relevanceSortText;
        case 'newest':
            return contentProps.dateSortText;
        case 'oldest':
            return contentProps.reverseDateSortText;
    }
}